import React from 'react';
import * as S from './References.styles';

const currentYear = new Date().getFullYear();

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>
        Copyright &copy; {currentYear == 2024 ? currentYear : `2024-${currentYear}`} e-MIP. All rights reserved.
      </S.Text>
    </S.ReferencesWrapper>
  );
};
